import axios from "utils/axios";
import { stringify } from "query-string";

export const getPettyCashCategories = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/pettycashCategories/pagination?${query}`);
};

export const getPettyCashCategory = (id) => {
  return axios.get(`/hr/pettycashCategories/${id}`);
};

export const addPettyCashCategory = (data) => {
  return axios.post(`/hr/pettycashCategories`, data);
};

export const editPettyCashCategory = (data) => {
  return axios.put(`/hr/pettycashCategories/${data?.id}`, data);
};

export const deletePettyCashCategory = (id) => {
  return axios.delete(`/hr/pettycashCategories/${id}`);
};
